'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dispatcher = require('./dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Actions, which are exposed to the developer, to interact with the NotificationContainer.
 * 
 * @author Timo Hanisch <timohanisch@googlemail.com>
 * @since 0.1.0
 */
var NotificationActions = function () {
    function NotificationActions() {
        _classCallCheck(this, NotificationActions);
    }

    _createClass(NotificationActions, [{
        key: 'addNotification',


        /**
         * Adds the given notifcation to the system so it then can be rendered 
         * in a NotifcationContainer.
         * 
         * @param {*} notification Notificaton which should be added and shown
         */
        value: function addNotification(notification) {
            _dispatcher2.default.dispatch({
                type: _constants.ADD_NOTIFICATION,
                data: notification
            });
        }

        /**
         * Removes the notifcation with the given id from the store.
         * 
         * @param {Number} notificationId Id of the notification to be removed
         */

    }, {
        key: 'removeNotification',
        value: function removeNotification(notificationId) {
            _dispatcher2.default.dispatch({
                type: _constants.REMOVE_NOTIFICATION,
                data: notificationId
            });
        }

        /**
         * Removes all notifications from the internal store.
         */

    }, {
        key: 'resetNotifications',
        value: function resetNotifications() {
            _dispatcher2.default.dispatch({
                type: _constants.RESET_NOTIFICATIONS
            });
        }
    }]);

    return NotificationActions;
}();

exports.default = new NotificationActions();
module.exports = exports['default'];